module.exports = __webpack_public_path__ + "img/work-with-02.6a83143.png";